import { render, staticRenderFns } from "./librariesList.vue.html?vue&type=template&id=bc079b40&"
import script from "./librariesList.ts?vue&type=script&lang=ts&"
export * from "./librariesList.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports